var installedModules = {};
var moduleToHandlerMapping = {
	2598: {
		getter: () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(6540))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	8186: {
		getter: () => (__webpack_require__.e(342).then(() => (() => (__webpack_require__(961))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	9332: {
		getter: () => (Promise.all([__webpack_require__.e(443), __webpack_require__.e(445)]).then(() => (() => (__webpack_require__(3443))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "4.1.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "mobx-react-lite",
	},
	689: {
		getter: () => (Promise.all([__webpack_require__.e(985), __webpack_require__.e(71)]).then(() => (() => (__webpack_require__(3985))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "5.85.3",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@tanstack/react-query-persist-client",
	},
	5843: {
		getter: () => (Promise.all([__webpack_require__.e(136), __webpack_require__.e(445), __webpack_require__.e(689)]).then(() => (() => (__webpack_require__(2136))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@pflm-shared",
	},
	7445: {
		getter: () => (__webpack_require__.e(813).then(() => (() => (__webpack_require__(7813))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "6.13.7",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "mobx",
	},
	2071: {
		getter: () => (__webpack_require__.e(946).then(() => (() => (__webpack_require__(3946))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "5.85.3",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@tanstack/react-query",
	},
	9733: {
		getter: () => (__webpack_require__.e(996).then(() => (() => (__webpack_require__(3996))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "7.8.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-router-dom",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"71": [
		2071
	],
	"186": [
		8186
	],
	"332": [
		9332
	],
	"445": [
		7445
	],
	"544": [
		9733
	],
	"598": [
		2598
	],
	"689": [
		689
	],
	"843": [
		5843
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}